import { useContext, useState } from "react";
import Header from "../components/organisms/Header";
import SecondTabNavigation from "../components/organisms/SecondTabNavigation";
import SideNavigation from "../components/organisms/SideNavigation";
import { RoleContext } from "../RoleContext";

const MainLayout = ({ children }) => {
  const [expanded, setExpanded] = useState(false);
  const sideNavWidth = expanded ? 265 : 64;
  const { role } = useContext(RoleContext);

  return (
    <div
      style={{
        display: "flex",
        minHeight: "100vh",
        backgroundColor: "#f8f9fa",
      }}
    >
      <SideNavigation
        expanded={expanded}
        setExpanded={setExpanded}
        role={role}
      />
      <div
        style={{
          flex: 1,
          marginLeft: sideNavWidth,
          transition: "margin-left 0.3s ease",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Header expanded={expanded} setExpanded={setExpanded} role={role} />

        {/* Main content area */}
        <div
          style={{
            marginTop: "64px",
            flex: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >

          {/* Page Content */}
          <div
            style={{
              flex: 1,
              padding: "0",
              backgroundColor: "#f8f9fa",
            }}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
